import {useForm} from "react-hook-form";
import {DropzoneField} from "./DropzoneField";
import React, {useEffect, useState} from "react";
import {IconButton, Stack} from "@mui/material";
import {fileFormatter} from "../../utils/formatters/fileFormatter";
import {FileBase, FileBaseFields} from "../../types/solicitation/solicitationFile";
import {LoaderBlockUI} from "../loader";
import {useAction} from "../../hooks/useAction";
import {CloseTwoTone} from "@mui/icons-material";
import Divider from "@mui/material/Divider";


interface FormDocumentacion {
    dropzone_form: File[]
}

interface NewFileDropzoneFormProps {
    onSubmitFile?: (fileBase: FileBase, file: File) => Promise<number>,
    fileType?: number,
    onClose: () => void,
    onReload?: () => void
}
const NewFileDropzoneForm = ({onSubmitFile, fileType, onClose, onReload}: NewFileDropzoneFormProps) => {
    const [files, setFiles] = useState<File[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const {snackbarSuccess, snackbarError} = useAction()
    
    const formMethods = useForm<FormDocumentacion>()
    
    const onSubmit = (data: FormDocumentacion) => {
        if (onSubmitFile) {
            setLoading(true)
            const submittedFiles = data.dropzone_form.map((f) => 
                onSubmitFile({
                    [FileBaseFields.FileTypeCode]: fileType || 0,
                    [FileBaseFields.Observation]: '',
                    [FileBaseFields.FileDesc]: f?.name || ''
                } as FileBase, f))
            Promise.all(submittedFiles).then(() => {
                snackbarSuccess('Los archivos se adjuntaron correctamente.')
                onClose()
                onReload && onReload()
            })
                .catch(() => snackbarError('Ocurrió un error al adjuntar los archivos'))
                .finally(() => setLoading(false))
        }
    }
    
    const watchFile = formMethods.watch('dropzone_form')

    useEffect(() => {
        if (watchFile)
            setFiles(formMethods.getValues('dropzone_form') || undefined);

    }, [watchFile, formMethods.getValues])

    const onHandleDelete = (fileToRemove: File) => {
        const newFiles: File[] | undefined = files?.filter(x => x !== fileToRemove);

        if (newFiles && newFiles.length > 0)
            formMethods.setValue('dropzone_form', newFiles)
        else {
            formMethods.setValue('dropzone_form', [])
        }
    }
    
    return (
        <form id={'newFile-form-dropzone'} onSubmit={formMethods.handleSubmit(onSubmit)}>
            {
                !files?.length ?
                    <DropzoneField name={'dropzone_form'}
                                   multiple={true}
                                   control={formMethods.control}
                                   setValue={formMethods.setValue}
                    />
                    :
                    <Stack spacing={2}>
                        <DropzoneField name={'dropzone_form'}
                                       multiple={true}
                                       control={formMethods.control}
                                       setValue={formMethods.setValue}
                                       size={'small'}
                        />
                        <Divider/>
                        <Stack>
                            {
                                files.length !== 0 && files.map((file, idx) =>
                                    <Stack key={idx} direction={'row'} spacing={2} justifyContent={'space-between'}>
                                        <Stack spacing={2} direction={'row'} key={idx} alignItems={'center'}>
                                            {fileFormatter.getIconByFileName(file.name, {fontSize: 'large'})}
                                            <Stack>
                                                <strong> {file.name} </strong>
                                                {`${Math.floor(file.size / 1000)} Kb`}
                                            </Stack>
                                        </Stack>
                                        <IconButton onClick={() => onHandleDelete(file)}>
                                            <CloseTwoTone />
                                        </IconButton>
                                    </Stack>
                                )
                            }
                        </Stack>
                    </Stack>
            }
            {loading && <LoaderBlockUI />}
        </form>
    )
}


export default NewFileDropzoneForm